import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconColors = t0 => {
  const $ = _c(11);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M9.476 1.928c-2.99.346-5.491 2.763-5.953 5.752-.055.359-.069 6.02-.053 22.4L3.49 52l.148.638c.56 2.438 1.61 4.384 3.243 6.017 3.592 3.593 9.013 4.497 13.523 2.256.956-.475 36.176-20.802 37.068-21.394 1.491-.989 2.497-2.433 2.927-4.204.087-.359.112-.72.109-1.585-.005-1.231-.078-1.625-.477-2.584-.176-.422-4.887-8.664-5.53-9.672-.337-.53-1.46-1.632-1.861-1.826-.37-.178-1.017-.24-1.41-.134-.598.16-1.202.739-1.374 1.315-.106.353-.088.956.04 1.342.082.247.233.45.64.87.294.3.581.613.639.695.216.31 5.012 8.651 5.141 8.945.297.67.287 1.552-.024 2.297-.148.354-.562.87-.883 1.1-.312.224-27.449 15.906-27.476 15.878-.01-.01 4.156-7.247 9.258-16.082 5.505-9.536 9.35-16.26 9.458-16.544 1.17-3.053.128-6.438-2.536-8.244-.749-.508-9.383-5.45-9.797-5.607-.886-.338-1.398-.436-2.316-.445-.796-.007-.888.004-1.166.146-.371.19-.788.594-.963.934-.186.36-.226 1.125-.082 1.558.14.422.587.918 1.014 1.125.248.12.511.178 1.033.227.542.05.787.106 1.088.247.522.244 8.692 4.962 9.073 5.239.565.41.953 1.085 1.085 1.885.109.657.001 1.156-.413 1.923-.183.339-3.775 6.575-7.981 13.859L27.04 45.418l-.034-18.821c-.032-17.855-.04-18.845-.149-19.297-.713-2.942-3.023-5.024-5.961-5.375-.695-.083-10.702-.08-11.42.003m.169 4.03c-1.081.255-1.966 1.22-2.154 2.352-.051.307-.066 6.368-.051 21.706l.02 21.28.141.615c.362 1.57 1.038 2.811 2.125 3.899 1.431 1.432 3.164 2.195 5.186 2.284 3.466.153 6.654-2.086 7.704-5.408.39-1.232.366.333.346-23.182l-.018-21.472-.206-.434c-.242-.513-.781-1.105-1.223-1.346-.68-.37-.588-.365-6.344-.358-2.906.004-5.392.033-5.526.064" clipRule="evenodd" />;
    t4 = <path fill="currentColor" d="M19 42.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M19 28.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M19 14.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0" />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t2) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}{t4}</svg>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
IconColors.displayName = 'IconColors';